import { lazy } from 'react';

// One lazy instance shared by the routes and the Expired window gate, so
// switching between them keeps the same layout mounted instead of rebuilding it.
const LazyAuthenticatedLayout = lazy(
  () => import('src/components/ui/layouts/authenticated-layout/authenticated-layout'),
);

export { LazyAuthenticatedLayout };
